import _styled from "@emotion/styled/base";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../../../primitives/Rating/Summary/components/Container.js';
import { Title } from '../../../primitives/Rating/Summary/components/Title.js';
import { Stack } from '../../../primitives/Stack/index.js';
import { LabelMedium, LabelMediumBold, LabelSmall } from '../../../primitives/Typography/index.js';
export const Summary = /*#__PURE__*/_styled(forwardRef(({
  sentiment,
  badge,
  title,
  subtitle,
  categories,
  ...restProps
}, ref) => _jsxs(Container, {
  ...restProps,
  ref: ref,
  spacing: "large",
  children: [_jsxs(Stack, {
    children: [_jsx("div", {
      children: badge
    }), _jsxs(Stack, {
      spacing: "xSmall",
      children: [_jsx(Title, {
        sentiment: sentiment,
        children: title
      }), _jsx(LabelSmall, {
        color: "contentSecondary",
        children: subtitle
      })]
    })]
  }), categories && categories.length > 0 && _jsx(Stack, {
    direction: "row",
    spacing: "large",
    divider: true,
    dividerProps: {
      category: 'primary'
    },
    children: categories.map(({
      name,
      value
    }, index) => _jsxs(Stack, {
      spacing: "xSmall",
      children: [_jsx(LabelMedium, {
        children: name
      }), _jsx(LabelMediumBold, {
        children: value
      })]
    }, index))
  })]
})), {
  label: 'RatingSummary',
  target: "e1er9ayo0"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlN1bW1hcnkuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBU0ciLCJmaWxlIjoiU3VtbWFyeS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGpzeCBhcyBfanN4LCBqc3hzIGFzIF9qc3hzIH0gZnJvbSBcIkBlbW90aW9uL3JlYWN0L2pzeC1ydW50aW1lXCI7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBmb3J3YXJkUmVmIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgQ29udGFpbmVyIH0gZnJvbSAnLi4vLi4vLi4vcHJpbWl0aXZlcy9SYXRpbmcvU3VtbWFyeS9jb21wb25lbnRzL0NvbnRhaW5lci5qcyc7XG5pbXBvcnQgeyBUaXRsZSB9IGZyb20gJy4uLy4uLy4uL3ByaW1pdGl2ZXMvUmF0aW5nL1N1bW1hcnkvY29tcG9uZW50cy9UaXRsZS5qcyc7XG5pbXBvcnQgeyBTdGFjayB9IGZyb20gJy4uLy4uLy4uL3ByaW1pdGl2ZXMvU3RhY2svaW5kZXguanMnO1xuaW1wb3J0IHsgTGFiZWxNZWRpdW0sIExhYmVsTWVkaXVtQm9sZCwgTGFiZWxTbWFsbCwgfSBmcm9tICcuLi8uLi8uLi9wcmltaXRpdmVzL1R5cG9ncmFwaHkvaW5kZXguanMnO1xuZXhwb3J0IGNvbnN0IFN1bW1hcnkgPSBzdHlsZWQoZm9yd2FyZFJlZigoeyBzZW50aW1lbnQsIGJhZGdlLCB0aXRsZSwgc3VidGl0bGUsIGNhdGVnb3JpZXMsIC4uLnJlc3RQcm9wcyB9LCByZWYpID0+IChfanN4cyhDb250YWluZXIsIHsgLi4ucmVzdFByb3BzLCByZWY6IHJlZiwgc3BhY2luZzogXCJsYXJnZVwiLCBjaGlsZHJlbjogW19qc3hzKFN0YWNrLCB7IGNoaWxkcmVuOiBbX2pzeChcImRpdlwiLCB7IGNoaWxkcmVuOiBiYWRnZSB9KSwgX2pzeHMoU3RhY2ssIHsgc3BhY2luZzogXCJ4U21hbGxcIiwgY2hpbGRyZW46IFtfanN4KFRpdGxlLCB7IHNlbnRpbWVudDogc2VudGltZW50LCBjaGlsZHJlbjogdGl0bGUgfSksIF9qc3goTGFiZWxTbWFsbCwgeyBjb2xvcjogXCJjb250ZW50U2Vjb25kYXJ5XCIsIGNoaWxkcmVuOiBzdWJ0aXRsZSB9KV0gfSldIH0pLCBjYXRlZ29yaWVzICYmIGNhdGVnb3JpZXMubGVuZ3RoID4gMCAmJiAoX2pzeChTdGFjaywgeyBkaXJlY3Rpb246IFwicm93XCIsIHNwYWNpbmc6IFwibGFyZ2VcIiwgZGl2aWRlcjogdHJ1ZSwgZGl2aWRlclByb3BzOiB7IGNhdGVnb3J5OiAncHJpbWFyeScgfSwgY2hpbGRyZW46IGNhdGVnb3JpZXMubWFwKCh7IG5hbWUsIHZhbHVlIH0sIGluZGV4KSA9PiAoX2pzeHMoU3RhY2ssIHsgc3BhY2luZzogXCJ4U21hbGxcIiwgY2hpbGRyZW46IFtfanN4KExhYmVsTWVkaXVtLCB7IGNoaWxkcmVuOiBuYW1lIH0pLCBfanN4KExhYmVsTWVkaXVtQm9sZCwgeyBjaGlsZHJlbjogdmFsdWUgfSldIH0sIGluZGV4KSkpIH0pKV0gfSkpKSwge1xuICAgIGxhYmVsOiAnUmF0aW5nU3VtbWFyeScsXG59KSBgYDtcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPVN1bW1hcnkuanMubWFwIl19 */");